import type { FilterOptionListProps } from '@components/FilterOptionList';
import FilterOptionList from '@components/FilterOptionList';
import type { FilterOptionPercentSale as FilterOptionPercentSaleType } from '@providers/FilterProvider';
import { formatPercentSaleLabel } from '@utils';

export type FilterOptionPercentSaleProps = Omit<
  FilterOptionListProps<FilterOptionPercentSaleType>,
  'filterOptionItemProps'
>;

const formatPercentSaleValue = (to: number, from?: number) => {
  return `${from || ''}:${to || ''}`;
};

const FilterOptionPercentSale = (props: FilterOptionPercentSaleProps) => {
  return (
    <FilterOptionList
      {...props}
      filterOptionItemProps={({ from, to, doc_count }) => ({
        value: formatPercentSaleValue(to, from),
        label: formatPercentSaleLabel(to, from),
        docCount: doc_count,
      })}
    />
  );
};

export default FilterOptionPercentSale;
